<template>
    <div id="live-diamond-feed">
        <div :class="{ container: !isIframe }">
            <paging-navigator :links="getPagingLinks"></paging-navigator>
            <div class="products" v-if="!isPopupActive">
                <filters-area browser-switcher="false"> </filters-area>
                <loading v-if="isLoading"></loading>
                <div v-show="!isLoading">
                    <cards-area :objectsToShow="diamondsToShow" :store="getUrl"></cards-area>
                </div>
                <paging v-if="getPagesCount && getPagesCount > 1" :pages="getPagesCount"></paging>
            </div>

            <product-diamond v-if="isPopupActive"></product-diamond>
            <schedule-appointment
                :products="[currentDiamond]"
                @closePopup="closeSchedulePopup"
                v-if="popupContent === 'schedule-appointment'"></schedule-appointment>

            <successfully-loaded />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import CardsArea from "../category/components/CardsArea.vue";
import SuccessfullyLoaded from "../../components/SuccessfullyLoaded";
import FiltersArea from "../category/components/FiltersArea.vue";
import Loading from "../../components/Loading.vue";
import Paging from "../../components/Paging.vue";
import DiamondVue from "../product/Diamond.vue";
import Popup from "../wishlist/Popup";
import PagingNavigatorVue from "../../components/PagingNavigator.vue";
import { createDiamondUrl } from "../../helpers";
import { DataLayer } from "../../mixins/DataLayer";

export default {
    name: "live-showcase",
    mixins: [DataLayer],
    props: ["url", "routeProps"],
    data: function () {
        return {
            popupContent: "product-diamond",
            isPopupActive: false,
            closeModalPath: "",
        };
    },
    components: {
        "filters-area": FiltersArea,
        "cards-area": CardsArea,
        loading: Loading,
        paging: Paging,
        "product-diamond": DiamondVue,
        "schedule-appointment": Popup,
        "paging-navigator": PagingNavigatorVue,
        "successfully-loaded": SuccessfullyLoaded,
    },
    watch: {
        routeProps(newVal, oldVal) {
            debugger;
            if (typeof newVal !== "undefined" && typeof this.routeProps !== "undefined") {
                this.getDiamonds(this.routeProps);
            }
        },
        currentDiamond(newVal) {
            if (typeof newVal === "object") {
                this.sendGADetails(this.currentDiamond);
            }
        },
        $route(to, from) {
            to.name === "live-showcase" ? (this.popupContent = "product-diamond") : (this.isPopupActive = true);

            if (!this.isPopupActive) {
                this.closeModalPath = from.fullpath;
            }
            this.isPopupActive = this.$route.params.diamondUrl ? true : false;
            this.isPopupActive ? this.mountStone() : null;

            if (this.$route.name === "schedule-popup" || this.$route.name === "diamonds-page-schedule-popup") {
                this.popupContent = "schedule-appointment";
                this.isPopupActive = true;
            }
        },
    },
    methods: {
        ...mapActions("willyou", [
            "getStoreData",
            "getDiamonds",
            "getDiamondProduct",
            "setCurrentPage",
            "setCurrentPath",
            "addDiamondToState",
            "activateStoreMode",
            "setIsDiamondsPage",
        ]),
        mountStone() {
            this.getDiamondProduct({
                diamondId: this.getDiamondId,
                router: this.$router,
            });
        },
        closeModal() {
            this.addDiamondToState(null);
            this.isPopupActive = false;
            // this.closeModalPath !== null ? this.$router.push({path: this.closeModalPath}) : this.$router.push({path: `/jewelers/${this.getUrl}/live-showcase`});
            this.$router.push({ path: `/jewelers/${this.getUrl}/live-showcase` });
        },
        diamondInArray() {
            return this.currentDiamondExists ? [this.currentDiamond] : null;
        },
        closeSchedulePopup() {
            this.popupContent = "product-diamond";
            let destination = !this.isDiamondsPage
                ? `/jewelers/${this.getUrl}/live-diamond-feed/${this.getCurrentDiamond}`
                : `/diamonds/${createDiamondUrl(this.currentDiamond)}`;
            this.$router.push(destination);
        },
    },
    computed: {
        ...mapState("willyou", [
            "diamonds",
            "isLoading",
            "currentStore",
            "totalPagesToShow",
            "storeMode",
            "currentDiamond",
            "iframeMode",
            "states",
            "isDiamondsPage",
        ]),
        ...mapGetters("willyou", ["getCurrentMeta"]),
        isIframe() {
            return this.iframeMode === true;
        },
        currentDiamondExists() {
            return this.currentDiamond !== null;
        },
        diamondsToShow() {
            return this.diamonds;
        },
        user() {
            return this.routeProps ? this.routeProps.user : null;
        },
        getUrl() {
            return this.isDiamondsPageRoute ? "diamonds" : this.$route.params.url;
        },
        isDiamondsPageRoute() {
            return this.$route.name === "diamonds-page-diamond-popup" || this.$route.name === "diamonds-page-schedule-popup";
        },
        getPagesCount() {
            return this.totalPagesToShow ? this.totalPagesToShow : Math.ceil(this.sortedDiamonds.length / this.elementsInPage);
        },
        getCurrentDiamond() {
            let currentDiam = this.currentDiamond ? `${this.currentDiamond.internal_lot} ${this.currentDiamond.name}` : "";
            return currentDiam.split(" ").join("-");
        },
        getDiamondId() {
            return this.$route.params.diamondUrl.split("-")[0];
        },
        getStoreCityState() {
            if (this.currentStore) {
                return [this.currentStore.state, this.currentStore.city];
            } else {
                return null;
            }
        },
        getPagingLinks() {
            let links = [
                {
                    name: "Live Diamond Feed",
                    url: { name: "live-showcase" },
                },
            ];

            if (this.$route.name !== "live-showcase") {
                links.push({
                    name: this.getCurrentDiamond,
                    url: {
                        name: "diamond-popup",
                        url: this.getUrl,
                        diamondUrl: this.getCurrentDiamond,
                    },
                });
            }

            if (this.isDiamondsPage && this.currentDiamond) {
                links = [
                    { name: "Home", url: "/" },
                    { name: "Diamonds", url: "/diamonds" },
                    {
                        name: this.getCurrentDiamond,
                        url: `/diamonds/${createDiamondUrl(this.currentDiamond)}`,
                    },
                ];
            }

            return links;
        },
    },
    mounted() {
        this.isDiamondsPageRoute ? this.setIsDiamondsPage() : null;
        this.activateStoreMode();
        !this.currentStore || !this.currentStore.url ? this.getStoreData({ url: this.getUrl, router: this.$router, ldf: true }) : null;
        if (!this.isDiamondsPageRoute) {
            this.getDiamonds(this.routeProps);
            this.$route ? this.setCurrentPage(this.$route.name) : null;
            this.$route ? this.setCurrentPath(this.$route.fullPath) : null;
        }
        // this.getDiamonds(this.routeProps);

        this.isPopupActive = this.$route.params.diamondUrl ? true : false;
        // this.$route.params.diamondUrl ? this.mountStone() : null;
    },
    metaInfo() {
        const currentMeta = this.getCurrentMeta;
        const storeCityState = this.getStoreCityState;
        const currentStateFromInit = this.states && storeCityState ? this.states.find((s) => s.shortName == storeCityState["0"]) : null;
        const currentCityFromInit = currentStateFromInit
            ? currentStateFromInit.cities.find((c) => (c.Name && c.storesCount ? c.Name.toLowerCase() === storeCityState["1"] && c.storesCount > 0 : false))
            : null;
        if (this.currentStore && this.currentStore.url) {
            currentMeta.link = [{ rel: "canonical", href: `https://willyou.net/diamonds` }];
        }

        // Seo requirement to completely remove meta robots tag.   (only inside a real LDF page)
        if (this.$route.name === "live-showcase") currentMeta.meta = currentMeta.meta.filter((m) => (m.name ? m.name !== "robots" : true));

        return currentMeta;
    },
};
</script>

<style lang="scss" scoped>
#live-diamond-feed {
    padding-top: 120px;
}
@media (max-width: 767px) {
    .modal {
        overflow: scroll;
    }
    #product-diamond {
        padding-top: 0;
    }
}
</style>
